const ENV = {
  MODE: "dev",
  BACKEND: "",
  BACKEND_URL_DEV: "",
};

export default ENV;
